import React from 'react'
import ManagersList from '../../components/Managers/ManagersTbale'

export const ManagerPage = () => {
  return (
    <>
    <ManagersList/>
    </>
  )
}
